import React, {useState, useRef, useEffect} from 'react';
import styles from './styles';
import {readMessagesByThread, sendMessage} from '../../Hooks';
import MessageThread from '../MessageThread';
import MessageInput from '../MessageInput';


const Portal = props => {

  const thread = props.thread || {};
  const [messages, setMessages] = useState(undefined);
  const [keyControl, setKeyControl] = useState(0);
  const hasFetched = useRef(false);
  const lastThread = useRef(null)
  // mounted state
  const isMounted = useRef(true);
  useEffect(() => () => isMounted.current = false, []);


  // messages fetch function
  const fetchMessages = (newId) => readMessagesByThread(
    newId || thread._id,
    res => setMessages(res.data.reverse()),
    err => console.error(err), props.apiUrl, props.headers
  );

  // handle repetitive thread fetch
  const repeater = useRef(null);
  const repeatingFetcher = () => setTimeout(() => {
    if (isMounted.current) {
      fetchMessages(lastThread.current);
      repeatingFetcher();
    }
  }, 4000);

  // reset after nct change
  if (props.thread && props.thread !== lastThread.current) {
    lastThread.current = props.thread;
    fetchMessages();
  }

  // fetch messages on load
  if (!hasFetched.current) {
    hasFetched.current = true;
    fetchMessages();
    if (repeater.current === null) repeater.current = repeatingFetcher();
  }

  // add sending message
  const startSend = (content) => {
    const messageId = Math.random().toString(36).substring(7);
    let copy = messages.slice();
    messages.push({
      ...content,
      messageId,
      status: 'sending',
    })
    setMessages(copy);
  }

  // handle message send
  const sendNewMessage = message => {
    console.log(message, "MESSAGE");
    startSend();
    sendMessage({
      content: message.message,
      sender: props.user.email,
      threadId: props.thread._id || props.thread.thread._id,
    }, () => {
      fetchMessages();
      setKeyControl(keyControl + 1);
    }, err => console.error(err), props.apiUrl, props.headers)
  }


  return(
      <div style={styles.container}>
        <MessageThread
          messages={messages}
          user={props.user}
        />
        <MessageInput
          key={keyControl + '_mikey'}
          subject={props.data && props.data.subject}
          patientId={props.patientId}
          sendNewMessage={sendNewMessage}
          apiUrl={props.apiUrl}
          headers={props.headers}
        />
      </div>
  );
}

export default Portal;
